import { ComponentPropsWithRef } from "react";

export const RegenerateIcon = (props: ComponentPropsWithRef<"svg">) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      d="M17.05 2.9375C16.1249 2.00606 15.0245 1.26695 13.8124 0.762789C12.6002 0.258627 11.3003 -0.000617944 9.9875 1.10606e-06C4.4625 1.10606e-06 0 4.475 0 10C0 15.525 4.4625 20 9.9875 20C14.65 20 18.5375 16.8125 19.65 12.5H17.05C16.5351 13.9619 15.5792 15.228 14.3142 16.1235C13.0492 17.0191 11.5374 17.5001 9.9875 17.5C5.85 17.5 2.4875 14.1375 2.4875 10C2.4875 5.8625 5.85 2.5 9.9875 2.5C12.0625 2.5 13.9125 3.3625 15.2625 4.725L11.2375 8.75H19.9875V1.10606e-06L17.05 2.9375Z"
      fill="currentColor"
    />
  </svg>
);
